import { createContext } from "react";

const ChapterContext = createContext();

export default ChapterContext;